document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('[id^="care-team-slider-"]')

  sliders.forEach((section) => {
    if (!section) return

    const swiperEl = section.querySelector('.care-team-slider__swiper')
    if (!swiperEl) return

    // Get settings from data attributes
    const showNavigation = section.dataset.showNavigation !== 'false'
    const showPagination = section.dataset.showPagination === 'true'
    const autoplay = section.dataset.autoplay === 'true'
    const autoplayDelay = parseInt(section.dataset.autoplayDelay) || 5000
    const loop = section.dataset.loop !== 'false'

    // Find navigation and pagination elements
    const prevBtn = section.querySelector('.care-team-slider__nav-btn--prev')
    const nextBtn = section.querySelector('.care-team-slider__nav-btn--next')
    const paginationEl = section.querySelector('.care-team-slider__pagination')

    // Initialize Swiper
    // eslint-disable-next-line no-undef, no-unused-vars
    const careTeamSwiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      grabCursor: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      centeredSlides: false,
      loop,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous team member',
        nextSlideMessage: 'Next team member'
      },
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      breakpoints: {
        320: {
          slidesPerView: 'auto',
          spaceBetween: 12,
          centeredSlides: false,
          slidesOffsetBefore: 30,
          slidesOffsetAfter: 30
        },
        750: {
          slidesPerView: 'auto',
          spaceBetween: 30,
          centeredSlides: false,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        990: {
          slidesPerView: 'auto',
          spaceBetween: 30,
          centeredSlides: false
        }
      },
      navigation: showNavigation && prevBtn && nextBtn
        ? {
            nextEl: nextBtn,
            prevEl: prevBtn
          }
        : false,
      pagination: showPagination && paginationEl
        ? {
            el: paginationEl,
            clickable: true,
            type: 'bullets'
          }
        : false,
      autoplay: autoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,
      watchOverflow: true,
      on: {
        init: function () {
          if (this.isLocked) {
            section.classList.add('care-team-slider--locked')
          }
        },
        resize: function () {
          if (this.isLocked) {
            section.classList.add('care-team-slider--locked')
          } else {
            section.classList.remove('care-team-slider--locked')
          }
        }
      }
    })
  })
})
